import { ReactNode, createElement } from 'react';

interface FooterSectionProps {
  /** Accessible heading level (h2 or h3). Use h2 for main sections if no other h2 in footer. */
  headingLevel?: 'h2' | 'h3';
  title: string;
  children: ReactNode;
  /** Optional id for the heading (for in-page links or aria) */
  id?: string;
}

export function FooterSection({
  headingLevel = 'h3',
  title,
  children,
  id,
}: FooterSectionProps) {
  return (
    <section aria-labelledby={id || undefined} className="text-left">
      {createElement(
        headingLevel,
        {
          id: id || undefined,
          className: 'text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4 text-left',
        },
        title
      )}
      {children}
    </section>
  );
}
